import script from "./CircuitBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./CircuitBoard.vue?vue&type=script&setup=true&lang=js"

import "./CircuitBoard.vue?vue&type=style&index=0&id=fc0580b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc0580b2"]])

export default __exports__